export const addEllipsis = (text) => {
    if(text.length > 50) {
        return text.substring(0, 50) + '...';
    }
}
 export function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }